export default "__VITE_ASSET__xnAYDxpd__"